const getTokenSymbol = (input: string): string => {
  return input.substring(input.lastIndexOf('_') + 1);
};

export default getTokenSymbol;
